module.exports = __webpack_public_path__ + "static/media/mmPic-min.32d07bbb.png";